import { render, staticRenderFns } from "./ui-menu.vue?vue&type=template&id=d15a6ab6&scoped=true"
import script from "./ui-menu.vue?vue&type=script&lang=ts"
export * from "./ui-menu.vue?vue&type=script&lang=ts"
import style0 from "./ui-menu.vue?vue&type=style&index=0&id=d15a6ab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15a6ab6",
  null
  
)

export default component.exports